import { render, staticRenderFns } from "./LoadMoreBtn.vue?vue&type=template&id=08c7119e&scoped=true"
import script from "./LoadMoreBtn.vue?vue&type=script&lang=js"
export * from "./LoadMoreBtn.vue?vue&type=script&lang=js"
import style0 from "./LoadMoreBtn.vue?vue&type=style&index=0&id=08c7119e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7119e",
  null
  
)

export default component.exports